import React, { Component } from "react";
import { AppContext } from "@my-dld/contexts/AppContext";
import MessagePopup from "./Popup/MessagePopup";
import { StringUtil } from "@eres/core";
import MessageInfoPopup from "./Popup/MessageInfoPopup";

class AppMessage extends Component {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	render() {
		let loaderClass = "loader-container show";
		if ( !StringUtil.isEmptyStringOrNull( this.context.loaderExtraClass ) )
			loaderClass = loaderClass + " " + this.context.loaderExtraClass;
		return (
			<React.Fragment>
				{ this.context.isLoading &&
					<div className={ loaderClass } id="my-loading" style={ { display: "block" } }>
						<div className="cs-loader">
							<div className="cs-loader-inner">
								<span>●</span>
								<span>●</span>
								<span>●</span>
								<span>●</span>
								<span>●</span>
								<span>●</span>
							</div>
						</div>
					</div>
				}
				{ this.context.message &&
					<MessagePopup message={ this.context.message } isError={ false }/>
				}
				{ this.context.error &&
					<MessagePopup message={ this.context.error } isError={ true }/>
				}
				{ this.context.info &&
					<MessageInfoPopup data={ this.context.info }/>
				}
			</React.Fragment>
		);
	}
}

export default AppMessage;
